import styled from 'styled-components';

export const Container = styled.textarea`
  width: 100%;
  float: left;
  font-size: 1.6rem;
  border: none;
  height: 20rem;
  padding: 1rem;
  line-height: 2rem;
  background: none;
  font-weight: 500;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 0.6rem;
  color: ${({ theme }) => theme.colors.TEXT1};

  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;
